import React, { Component } from 'react';


export default class TermsAndConditions extends Component {


    constructor(props) {
        super(props);

        this.state = {
            errorMsgText: "",
            disableButtons: false,
            chkAcceptTOUDT: false,
            disabledTOUAcceptedBtn: false,
            needTOUConfirm: false,
        }
    }
    enableDisableTOUBtn(enableIt) {
        this.setState({ disabledTOUAcceptedBtn: !enableIt });
    }
    onchkAcceptTOUClick() {
        this.setState({ chkAcceptTOUDT: !this.state.chkAcceptTOUDT },
            () => {
                this.enableDisableTOUBtn(this.state.chkAcceptTOUDT);
            })
    }
    onAcceptTOUChkClick() {
        if (this.refs.chkAcceptTOU)
            this.enableDisableTOUBtn(this.refs.chkAcceptTOU.checked);
    }

    onTermKeyPress(e) {
        if (e.charCode == 13 || e.charCode == 32) {
            e.preventDefault();
            this.onchkAcceptTOUClick();
        }

    }
    
    render() {
        let chkAcceptTOUClass = "form1-bu-close";

        if (this.props.showAcceptTOUPnl && (!this.state.chkAcceptTOUDT)) {
            chkAcceptTOUClass = "form1-bu-close-d"
        }
        
        return (
            <table id='TOU' style={{ zIndex: '101', backgroundColor: "transparent" }} >
                <tbody>
                <tr style={{ height: '1px' }}>
                    <td>
                    </td>
                        <td id='TOUContent' style={{
                            borderWidth: '0px', borderStyle: 'solid', borderRadius: "5px", width: '590px',
                            /*height: '420px',*/
                            borderColor: "grey", backgoundColor: "transparent", padding: "5px 30px"
                        }}>
                            <table className='wh100'  >
                            <tbody>
                            <tr>
                                <td id='touText' style={{ verticalAlign: 'top', borderColor: "grey", borderWidth: "0px" }}>
                                    {(_PRODUCTINFO.TOUURL || "").length > 0 ?
                                        <iframe frameBorder="0" src={_PRODUCTINFO.TOUURL} className="termsFrame wh100 " style={{ height: "300px", paddingRight: "3px" }}
                                            
                                        ></iframe>
                                        : "Problem in loading Terms of Use"}
                                </td>
                            </tr>
                            <tr style={{ height: '1px' }}>
                                <td style={{ textAlign: 'left', padding: "20px 0px" }}>
                                            <table className='w100' id='touBtns's>
                                                <tr style={{ display: 'flex', flexDirection: 'column' }}>
                                            <td>

                                                {this.AcceptPanel()}
                                                    </td>
                                                    <td style={{ marginTop: '10px', alignSelf: 'center' }}>

                                                <input id='btnTOUAccepted' type='button' tabIndex="10"
                                                            value={this.props.showAcceptTOUPnl ? "Continue" : "Close"} className={chkAcceptTOUClass}
                                                    disabled={this.state.disabledTOUAcceptedBtn} onClick={(e) => this.onHideClick(e)} />
                                            </td>
                                        </tr>
                                    </table>

                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </td>
                    <td>
                    </td>
                    </tr>
                </tbody>
            </table>
        );

    }
    AcceptPanel() {

        if (this.props.showAcceptTOUPnl)
            return (<div id='pnlAcceptTOU'>

                <div tabIndex="9" onKeyPress={(e) => this.onTermKeyPress(e)} onClick={() => this.onchkAcceptTOUClick()}>
                    {this.state.chkAcceptTOUDT ?
                        (<img src="images/tick2.png" className="terms-footer-checkBox-circle-checked" />
                        )
                        :
                        (
                            <span className="terms-footer-checkBox-circle" onClick={() => this.onchkAcceptTOUClick()}>
                                <span className="terms-footer-checkBox-text">hiet</span>
                            </span>
                        )
                    }
                    <span className="terms-footer-checkBox-text">hi</span><span className=''>I accept the Terms of Use</span>
                        </div>

            </div>);



    }


    onHideClick() {
        if (!this.props.showAcceptTOUPnl) {
            this.props.onHideClick();
            return;
        }

        fetch(window.baseUrl + 'Login/TermsOfUseAcceptedClick', {
            method: 'POST', // or 'POST'
            headers: {
                'Content-Type': 'application/json',
            },
            body: '',
        })
            .then(response => {
                return response.json()
            })
            .then(repdata => {
                if (repdata) {
                    this.props.onHideClick(repdata);
                    return;
                }
            })
            .catch((error) => {

                console.error('Error:', error);
            });




    }





}
